// Copyright 2022 - 2023 Fewcha. All rights reserved.

import App from "components/App/App";
import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import "services/web3";
import "styles/index.scss";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
